import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class VoteTypeOptions extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'VoteTypeOptions'
  // Define default properties here
  static instanceDefaults () {
    return {
      option: '',
      value: null,
      voteTypeId: null,
      position: 0,
    }
  }
}
const servicePath = 'vote-type-options'
const servicePlugin = makeServicePlugin({
  Model: VoteTypeOptions,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
